import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getAccountInfo,
  getAllTransactions,
  downloadTransactions,
  resetTransPage,
} from 'ducks/transactions';
import withScrollableTopTabs from 'hoc/withScrollableTopTabs';
import customerPageTopTabs from 'constants/customerPageTopTabs';
import Transactions from './Transactions';

const mapStateToProps = (state) => ({
  localisation: state.localisation,
  permissions: state.auth.permissions,
  transactions: state.transactions,
  token: state.auth.accessToken,
});

const mapDispatchToProps = {
  getAccountInfo,
  getAllTransactions,
  downloadTransactions,
  resetTransPage,
};

export default compose(
  withScrollableTopTabs(customerPageTopTabs, 2, ['adfitNo']),
  connect(mapStateToProps, mapDispatchToProps)
)(Transactions);
